import { getMailServerType } from "@apps/client-sdk";
import { createStatusController, el } from "../dom.js";
import { renderKerioFiltersPanel } from "./kerioFiltersPanel.js";
import { renderKerioOutOfOfficePanel } from "./kerioOooPanel.js";
export function renderKerioSieveSection(options) {
    const section = el("section", "card");
    section.append(el("h2", undefined, "Server Filters"));
    const status = el("p", "muted", "");
    section.append(status);
    const { showStatus } = createStatusController(status);
    const subnav = el("div", "sieve-subnav mt");
    const buttons = {
        ooo: el("button", "btn btn-secondary btn-sm sieve-subnav-btn active", "Out of Office"),
        filters: el("button", "btn btn-secondary btn-sm sieve-subnav-btn", "Filters"),
    };
    for (const btn of Object.values(buttons)) {
        btn.type = "button";
        subnav.append(btn);
    }
    section.append(subnav);
    const body = el("div", "sieve-subsection mt");
    section.append(body);
    let active = "ooo";
    const renderActive = () => {
        body.replaceChildren();
        if (active === "ooo") {
            body.append(renderKerioOutOfOfficePanel({
                storage: options.storage,
                showStatus,
            }));
        }
        else {
            body.append(renderKerioFiltersPanel({
                storage: options.storage,
                showStatus,
            }));
        }
    };
    const setActive = (next) => {
        if (next === active)
            return;
        active = next;
        for (const [id, btn] of Object.entries(buttons)) {
            btn.classList.toggle("active", id === next);
        }
        renderActive();
    };
    buttons.ooo.addEventListener("click", () => setActive("ooo"));
    buttons.filters.addEventListener("click", () => setActive("filters"));
    renderActive();
    return section;
}
/** Entry used by Server Filters tab — picks Kerio or Dovecot UI. */
export async function resolveMailServerType(storage) {
    try {
        return await getMailServerType(storage);
    }
    catch {
        return "dovecot";
    }
}
